import bloatingMealPrep from './bloating-meal-prep.js';
import bloodSugarControlMealPrep from './blood-sugar-control-meal-prep.js';
import catering from './catering.js';
import celiacDiseaseMealPrep from './celiac-disease-meal-prep.js';
import cholesterolMealPrep from './cholesterol-meal-prep.js';
import contactFormGeneral from './contact-form-general.js';
import contactFormPartners from './contact-form-partners.js';
import daycare from './daycare.js';
import faqs from './faqs.js';
import fatigueMealPrep from './fatigue-meal-prep.js';
import glp1MealPlan from './glp1-meal-plan.js';
import healthConditions from './health-conditions.js';
import healthGoals from './health-goals.js';
import hipaaNotice from './hipaa-notice.js';
import howToOrder from './how-to-order.js';
import hypertensionMealPrep from './hypertension-meal-prep.js';
import hypothyroidismMealPrep from './hypothyroidism-meal-prep.js';
import lactationMealPrep from './lactation-meal-prep.js';
import mealPlansForRunners from './meal-plans-for-runners.js';
import nutritionists from './nutritionists.js';
import postpartumHealthMealPrep from './postpartum-health-meal-prep.js';
import privacyPolicy from './privacy-policy.js';
import science from './science.js';
import pregnancyMealPrep from './pregnancy-meal-prep.js';
import preparedMealSubscription from './prepared-meal-subscription.js';
import stressMealPrep from './stress-meal-prep.js';
import termsAndConditions from './terms-and-conditions.js';
import theBridalCut from './the-bridal-cut.js';
import trainers from './trainers.js';
import weightLossMealPrep from './weight-loss-meal-prep.js';

const PAGES = {
  'bloating-meal-prep': bloatingMealPrep,
  'blood-sugar-control-meal-prep': bloodSugarControlMealPrep,
  catering: catering,
  'celiac-disease-meal-prep': celiacDiseaseMealPrep,
  'cholesterol-meal-prep': cholesterolMealPrep,
  'contact-form-general': contactFormGeneral,
  'contact-form-partners': contactFormPartners,
  daycare: daycare,
  faqs: faqs,
  'fatigue-meal-prep': fatigueMealPrep,
  'glp1-meal-plan': glp1MealPlan,
  'health-conditions': healthConditions,
  'health-goals': healthGoals,
  'hipaa-notice': hipaaNotice,
  'how-to-order': howToOrder,
  'hypertension-meal-prep': hypertensionMealPrep,
  'hypothyroidism-meal-prep': hypothyroidismMealPrep,
  'lactation-meal-prep': lactationMealPrep,
  'meal-plans-for-runners': mealPlansForRunners,
  nutritionists: nutritionists,
  'postpartum-health-meal-prep': postpartumHealthMealPrep,
  'pregnancy-meal-prep': pregnancyMealPrep,
  'privacy-policy': privacyPolicy,
  'prepared-meal-subscription': preparedMealSubscription,
  science: science,
  'stress-meal-prep': stressMealPrep,
  'terms-and-conditions': termsAndConditions,
  'the-bridal-cut': theBridalCut,
  trainers: trainers,
  'weight-loss-meal-prep': weightLossMealPrep,
};

export default PAGES;
